/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/first */
import './polyfills'

import React from 'react'
import ReactDOM from 'react-dom'
import settings from '@nobia/zeus-components/lib/settings'
import Root from '@nobia/zeus-components/lib/root'
import App from './app'
import './styles/global.css'
import './styles/overridePhotoGallery.css'

const renderApp = () => {
  const query = {}

  window.location.search
    .slice(1)
    .split('&')
    .forEach(c => {
      const s = c.split('=')
      if (s[0] && s[1]) {
        query[s[0]] = s[1]
      }
    })
  const brand =
    (settings.brandMappings &&
      settings.brandMappings[window.location.hostname]) ||
    settings.brand

  const urlParams = new URLSearchParams(window.location.search)
  const language = urlParams.get('language')
  const languageQueryString = language ? `?language=${language}` : ''
  const apiUrl =
    settings.gatewayAPI.replace('{brand}', brand) + languageQueryString

  const rootElement = document.getElementById('root')
  const embedBlockId = rootElement.parentElement.getAttribute(
    'data-embed-content-id'
  )

  ReactDOM.render(
    <Root apiUrl={apiUrl} brand={settings.brand}>
      <App embedBlockId={embedBlockId} />
    </Root>,
    rootElement
  )
}

renderApp()

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./app', renderApp)
}
